import { useState, useEffect } from 'react';
import { hot } from 'react-hot-loader';
//import { Link } from 'react-router-dom';
import { Link as ScrollLink, Events as ScrollEvents, } from 'react-scroll';
import LinkExternal from '../components/Link/LinkExternal';

import { useMediaPredicate } from 'react-media-hook';
import { mobileBreakpoint } from '../helpers/Media';

import MenuOpenIcon from './SvgRobo/MenuOpenIcon';
import MenuCloseIcon from './SvgRobo/MenuCloseIcon';
//import FacebookHeaderIcon from './SvgRobo/FacebookHeaderIcon';
//import InstagramHeaderIcon from './SvgRobo/InstagramHeaderIcon';
import TwitterHeaderIcon from './SvgRobo/TwitterHeaderIcon';
//import DiscordHeaderIcon from './SvgRobo/DiscordHeaderIcon';
import OpenSeaHeaderIcon from './SvgRobo/OpenSeaHeaderIcon';

import ButtonPrimary from './ButtonPrimary';
import ConnectWalletButton from './ConnectWalletButton';

import CoolLightBox from '../components/CoolLightBox';
import {
  //facebookUrl, instagramUrl, discordUrl,
  twitterUrl, openSeaUrl,
  youtubeTeaserUrl,
  networkChainId,
} from '../configs';
import './Header.scss';

import { useEagerConnect, useActiveWeb3React } from '../hooks/index';
import { useModal } from 'react-simple-modal-provider';

//import ReactPixel from 'react-facebook-pixel';


function Header({ fixed }) {
  const isMobile = useMediaPredicate(mobileBreakpoint);
  const [isMobileOpen, setMobileOpen] = useState(false);

  const triedEager = useEagerConnect();
  const context = useActiveWeb3React();
  const { chainId, account, active } = context;
  const accountShort = account
    ? `${account.substring(0, 6)}...${account.substring(account.length - 5)}`
    : 'Connect wallet';


  //const { open: openWalletAccountModal } = useModal('WalletAccountModal');
  const openWalletAccountModal = () => null;

  useEffect(() => {
    ScrollEvents.scrollEvent.register('begin', function (to, element) {
      setMobileOpen(false);
    });
    return () => {
      ScrollEvents.scrollEvent.remove('begin');
    };
  }, []);

  return (
    <header className={fixed ? "header header-fixed" : "header"} data-aos="fade-up">
      {isMobile && isMobileOpen && <div className="mobile__menu">
        <div className="container">
          <div className="mobile__menu-links">
            {/*<ScrollLink to="roadmap" className="mobile__menu-link" smooth={'true'} duration={500}>Roadmap</ScrollLink>*/}
            <ScrollLink to="collection" className="mobile__menu-link" smooth={'true'} duration={500}>Collection</ScrollLink>
            {/*<ScrollLink to="team" className="mobile__menu-link" smooth={'true'} duration={500}>Team</ScrollLink>*/}
            <CoolLightBox options={{ infinite: false }} >
              <LinkExternal className="mobile__menu-link" smooth={'true'}
                href={'#'}
                data-fancybox=""
                data-src={youtubeTeaserUrl}
              >Trailer</LinkExternal>
            </CoolLightBox>
            {/*<Link to="/howtobuy" className="mobile__menu-link">How to Buy?</Link>*/}
          </div>
        </div>
      </div>}

      <div className="container">
        <div className="menu__top">
          <div className="row justify-content-between align-items-center">
            {!isMobile && <div className="col-auto">
              <nav className="menu">
                {/*<ScrollLink to="roadmap" onClick={() => setMobileOpen(false)} className="nav-link">Roadmap</ScrollLink>*/}
                <ScrollLink to="collection" onClick={() => setMobileOpen(false)} className="nav-link">Collection</ScrollLink>
                {/*<ScrollLink to="team" onClick={() => setMobileOpen(false)} className="nav-link">Team</ScrollLink>*/}
                <CoolLightBox options={{ infinite: false }} >
                  <LinkExternal className="nav-link"
                    href={'#'}
                    data-fancybox=""
                    data-src={youtubeTeaserUrl}
                  >Trailer</LinkExternal>
                </CoolLightBox>
                {/*<Link to="/howtobuy" className="nav-link">How to Buy?</Link>*/}
              </nav>
            </div>}

            <div className="col-12 col-lg-auto">
              <div className="header-info">
                {isMobile && <div className="header-mmenu">
                  {!isMobileOpen && <MenuOpenIcon onClick={() => setMobileOpen(true)} />}
                  {isMobileOpen && <MenuCloseIcon onClick={() => setMobileOpen(false)} />}
                </div>}

                <div className="header-info__soc soc">
                  {/*<LinkExternal className="soc-link" href={facebookUrl}><FacebookHeaderIcon /></LinkExternal>
                  <LinkExternal className="soc-link" href={instagramUrl}><InstagramHeaderIcon /></LinkExternal>*/}
                  <LinkExternal className="soc-link" href={twitterUrl}><TwitterHeaderIcon /></LinkExternal>
                  {/*<LinkExternal
                    id='joinDiscord'
                    onClick={() => ReactPixel.track('Lead')}
                    className="soc-link" href={discordUrl}
                  ><DiscordHeaderIcon /></LinkExternal>*/}
                  <LinkExternal className="soc-link" href={openSeaUrl}><OpenSeaHeaderIcon /></LinkExternal>
                </div>

                <div className="header-info__wallet">
                  {(!triedEager || !active || !account)
                    && <ConnectWalletButton />
                  }
                  {(triedEager && active && account && chainId !== networkChainId)
                    && <ButtonPrimary tag="button" label={'Wrong network'} onClick={openWalletAccountModal} />
                  }
                  {(triedEager && active && account && chainId === networkChainId)
                    && <ButtonPrimary tag="button" label={accountShort} onClick={openWalletAccountModal} />
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default hot(module)(Header);
